


// 电销

import { collectionServiceClient } from "@/api/collectionServiceClient";
import { GetPhoneSaleCaseReq,SavePhoneSaleCaseReq,GetPhoneSaleCaseLogReq } from "@/pbjs/xcommon/phonesale_pb"; 

import { setCommon, setPage } from "@/utils/request";
import { Page, timeFormat } from "@/utils/index";

import InnerRequest from "./request";

export interface Options {
    Page: {
       pageIndex: any,
       pageSize: any,
       prop:  any,
       order: any
    };
    caseid:number;
    itemId:number
    ticketId: number; // Ticket Id
    phoneConnect:number,
    phoneCallInput:string,
    phoneTime:number,
    phoneResult:number,
    desc:string,
    result:number,
    callId:string,
    nextStep:number,
    birthday:string
    // action: string;
    // orderId: number; //借款id
    // isReloan: number; //首付贷 0：不选，1：复贷，2：首贷
    // itemId: Array<number>, //工单类型
    // verifyResult: number, //审核结果
    // inspectionResult: number, // 质检结果
    // createTimeRange: string, //创建时间
    // assignTimeRange: string, //分配时间
    // completeTimeRange: string, // 完成时间
    // previtemId: number;
}


export function getPhoneSaleCaseReq(arg: Options) {
    let request: any = new GetPhoneSaleCaseReq();
    request.setCaseid(arg.caseid);
    return request;
}
export const getPhoneSaleCaseRequest = new InnerRequest(
    collectionServiceClient,
    collectionServiceClient.getPhoneSaleCase
);


export function savePhoneSaleCaseReq(arg: Options) {
    let request: any = new SavePhoneSaleCaseReq();
    request.setItemid(arg.itemId);
    request.setCaseid(arg.caseid);
    request.setTicketid(arg.ticketId);
    request.setPhoneconnected(arg.phoneConnect);
    request.setPhonecallinput(arg.phoneCallInput);
    request.setPhonetime(arg.phoneTime);
    request.setPhoneresult(arg.phoneResult);
    request.setDesc(arg.desc);
    request.setResult(arg.result);
    request.setCallid(arg.callId);
    request.setNextstep(arg.nextStep);
    request.setBirthday(arg.birthday);
    return request;
}
export const savePhoneSaleCaseRequest = new InnerRequest(
    collectionServiceClient,
    collectionServiceClient.savePhoneSaleCase
);


export function getPhoneSaleCaseLogReq(arg: Options) {
    let request: any = new GetPhoneSaleCaseLogReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize,arg.Page.prop,arg.Page.order))
    request.setCaseid(arg.caseid);
    return request;
}
export const getPhoneSaleCaseLogRequest = new InnerRequest(
    collectionServiceClient,
    collectionServiceClient.getPhoneSaleCaseLog
);

